import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import Cookies from "js-cookie";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Loader from "react-spinners/RingLoader";
import config from "../../../config/apiConfig";
import { Chapter } from "../ReaderView";
import ChapterHeader from "./ChapterHeader/ChapterHeader";
import ReactHtmlParser, {
    convertNodeToElement,
    Options,
} from "react-html-parser";
import "./ChapterDetails.scss";
import withComments, {
    CommentProps,
    Comments,
    mapToComments,
} from "../../../hoc/withComments";
import CustomPara from "./CustomPara/CustomPara";
import ReactGA from "react-ga";

type Props = {
    storyId: string;
    chapter: Chapter;
    chapters: Chapter[];
    jump: (index: number) => void;
    goToNext: () => any;
    goToPrevious: () => any;
};

type ChapterDetail = {
    body: {
        raw?: string;
        html?: string;
    };
    chapter_number: number;
    comments: number;
    created_at: number;
    id: string;
    status: "draft" | "published";
    story_id: string;
    title: string;
    updated_at: number;
    views: number;
};

const ChapterDetails: React.FC<Props & CommentProps> = (props) => {
    const [chapter, setChapter] = useState<ChapterDetail | undefined>(
        undefined
    );
    const [isLoading, setIsLoading] = useState(false);
    const [chapterComments, setChapterComments] = useState<Comments[]>([]);

    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        const promise1 = fetch(
            config.BASE_URL +
                "/v1/get/writingtool/story/" +
                props.storyId +
                "/chapter/" +
                props.chapter.id +
                "/info",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setChapter(res.data));
        const promise2 = loadChapterComments();
        setIsLoading(true);
        Promise.all([promise1, promise2]).finally(() => setIsLoading(false));
    }, [props.chapter.id]);

    const loadChapterComments = () => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL +
                "/v1/get/showmilers/story/" +
                props.storyId +
                "/chapter/" +
                props.chapter.id +
                "/comments/all",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => {
                const comments = (res.data as any[]).map((d) =>
                    mapToComments(d)
                );
                const chComments = comments.filter(
                    (c) => c.comment_type === "chapter_comment"
                );
                chComments.sort(
                    (a, b) => a.created_at.getTime() - b.created_at.getTime()
                );
                setChapterComments(chComments);
            });
    };

    const addComment = async (comment: string) => {
        ReactGA.event({
            category: "Read Story",
            action: "Provide comment",
        });
        const formData = new FormData();
        formData.append("comment", comment);
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        await fetch(
            config.BASE_URL +
                "/v1/put/showmilers/story/" +
                props.storyId +
                "/chapter/" +
                props.chapter.id +
                "/comments/new",
            requestOptions
        );
        loadChapterComments();
        return [props.storyId, props.chapter.id];
    };

    if (isLoading || !!!chapter) return <Loader color="blue" />;

    // const options: Options = {
    //     transform: (node, index) => {
    //         if (node.type === "tag" && node.name === "p") {
    //             return (
    //                 <CustomPara
    //                     body={node.children[0]?.data}
    //                     toggle={(el) =>
    //                         props.renderNote({
    //                             comments: chapterComments,
    //                             el,
    //                             add: addComment,
    //                             delete: () => {},
    //                         })
    //                     }
    //                 />
    //             );
    //         }
    //     },
    // };

    const options = {};

    return (
        <div
            className="main__content chapter-details"
            style={{ height: "100vh" }}
        >
            <div className="story__detail" style={{ width: "800px" }}>
                <ChapterHeader
                    title={chapter.title}
                    chapters={props.chapters.map((c) => c.title)}
                    jump={props.jump}
                    views={chapter.views}
                    comments={chapter.comments}
                    toggle={(el) =>
                        props.renderNote({
                            comments: chapterComments,
                            el,
                            add: addComment,
                            delete: () => {},
                            right: "-16px",
                            top: "-40px",
                        })
                    }
                />
                <div style={{ padding: 16 }}></div>
                <article>
                    {ReactHtmlParser(chapter.body.html ?? "", options)}
                </article>
                <div style={{ display: "flex" }}>
                    <button
                        className="read__button"
                        onClick={(e) => props.goToPrevious()}
                        disabled={props.chapters[0].id === props.chapter.id}
                    >
                        <ArrowLeft />
                        <div>Go to Previous chapter</div>
                    </button>
                    <div style={{ padding: 8 }}></div>
                    <button
                        className="read__button"
                        onClick={(e) => props.goToNext()}
                        disabled={
                            props.chapters[props.chapters.length - 1].id ===
                            props.chapter.id
                        }
                    >
                        <div>Go to next chapter</div>
                        <ArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default withComments(ChapterDetails);
